import React, { useEffect } from 'react';
import axios from 'axios';

import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Redirect() {

  const navigate = useNavigate();
  useEffect(() => {

    let url = localStorage.getItem('UBs') ?? window.location.href.replaceAll("/estabelecimento", "");
    if (url.includes("localhost")) {
      url = "https://confeitariadanath.gustio.com.br/";
    }
    const urlBase = new URL(url).origin;

    let localUrl = window.location.href
    if (localUrl.includes("iSp=") || localStorage.getItem("DSlP") === "true") {
      localStorage.setItem('iSpA', true);
    } else {
      localStorage.removeItem("iSpA")
    }

    getConfig(urlBase);

    if (localStorage.getItem('isLogged')) {
      navigate("/");
    }

    if (localStorage.getItem('isLogged') && localStorage.getItem('isStore')) {
      navigate("/estabelecimento/home", { replace: true, state: { page: "home" } });
    }

    if (!localStorage.getItem('isLogged')) {
      navigate("/estabelecimento/login", { replace: true, state: { page: "home" } });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getConfig = (url) => {
    const urlBase = new URL(url).origin;
    axios.post(`https://gerenciador.gustio.com.br/api/configuracoes-cliente.php`, {
      urlBase: urlBase,
    })
      .then(resp => {
        const response = resp.data;
        console.log(response)
        if (response && response.length > 0) {
          
          const idCliente = response[0].id_cliente;

          localStorage.setItem('Mn', response[0].nome_cliente);
          localStorage.setItem('tD', response[0].tipo_entrega);
          localStorage.setItem('Md', idCliente);
          localStorage.setItem('UBs', `${urlBase}/api`);
          localStorage.setItem('UMs', response[0].url_whatsapp);
          localStorage.setItem('vlMnm', response[0].valor_minimo);
          localStorage.setItem('eNbS', response[0].habilita_cliente === "1");
          localStorage.setItem('eNbB', response[0].habilita_compra === "1");
          localStorage.setItem('eNbM', response[0].habilita_menu === "1");
          localStorage.setItem('tpLj', response[0].segmento_cliente);
          localStorage.setItem('pGap', response[0].habilita_pagamento === "1");
          localStorage.setItem('clPmr', response[0].cor_primaria);
          localStorage.setItem('clScr', response[0].cor_secundaria);
          localStorage.setItem('clTcr', response[0].cor_terciaria);

          document.title = response[0].nome_cliente;

          const favicon = document.querySelector('link[rel="icon"]');
          favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;
          //
          getInfos(urlBase, idCliente)
          getHorarios(urlBase, idCliente)
        }
      })
      .catch(error => console.log("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getInfos = (url, idCliente) => {
    axios.post(`${url}/api/avaliacoes.php`, {
      idestabelecimentos: idCliente ?? localStorage.getItem("Md")
    })
      .then(response => {
        const avaliacoes = response.data
        let notaTotal = 0, countNotas = 0
        if (avaliacoes) {
          for (const avaliacao of avaliacoes) {
            const partes = avaliacao.avaliacao.split(" -- ");
            notaTotal += parseInt(partes[0])
            countNotas++
          }
          notaTotal = notaTotal / countNotas
          notaTotal = notaTotal.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
          localStorage.setItem('MnT', notaTotal);
          return
        }
        localStorage.setItem('MnT', "4,5");
      })
      .catch(error => console.log("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  const getHorarios = (url, idCliente) => {
    axios.post(`${url}/api/horarios.php`, {
      idestabelecimentos: idCliente ?? localStorage.getItem("Md"),
    })
      .then(response => {
        response = response.data

        if (localStorage.getItem("FxEst") === "1") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado temporariamente</b>`);
          return
        }

        const horariosArray = response[0].horarios.split(",");
        const d = new Date();
        let diasemana
        if (d.getDay() === 0) {
          diasemana = horariosArray[6]
        } else {
          diasemana = horariosArray[d.getDay() - 1]
        }
        if (diasemana === "Fechado") {
          localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b>`);
        } else {
          var unix = Math.round(+new Date() / 1000);
          const horarios = diasemana.split(" às ");
          const horario1 = horarios[0].split(":");
          var unix1 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario1[0], horario1[1]) / 1000);
          const horario2 = horarios[1].split(":");
          var unix2 = Math.round(+new Date(d.getFullYear(), d.getMonth(), d.getDate(), horario2[0], horario2[1]) / 1000);

          if (parseInt(horario2[0]) < parseInt(horario1[0]) || (horarios[0] === "00:00" && horarios[1] === "00:00")) {
            unix2 += 86400
          }

          const arrTime = localStorage.getItem("tD").split("(")
          const tempo = arrTime[1].replaceAll(")", "")

          if (unix > unix1 && unix < unix2) {
            localStorage.setItem('sTA', `<b style="color:#33540E">Aberto</b> até ${horarios[1]} • ${tempo}`);
          } else {
            localStorage.setItem('sTA', `<b style="color:#A41D1D">Fechado</b> abre às ${horarios[0]}`);
          }
        }

      })
      .catch(error => console.log("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  return (
    <Container>

    </Container>
  );
}

export default Redirect;